import { render, staticRenderFns } from "./partnerRecruitment.vue?vue&type=template&id=5bd5179c&scoped=true&"
import script from "./partnerRecruitment.vue?vue&type=script&lang=js&"
export * from "./partnerRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./partnerRecruitment.vue?vue&type=style&index=0&id=5bd5179c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5179c",
  null
  
)

export default component.exports